import React from "react";
import Lottie from 'react-lottie';
import animationData from '../../assets/loader/Loader.json';

const SpinnerKw = (props) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        props?.percentage ?
        <div className="lottie-spin">
            <Lottie
                options={defaultOptions}
                height={400}
                width={400}
            />
            <span className='percentage-load'>{props.percentage+"%"}</span>
        </div>
        : 
        <Lottie
            options={defaultOptions}
            height={400}
            width={400}
        />
    );
};

export default SpinnerKw;

// import React from 'react';

// const SpinnerKw = props => {

//     const content = props.percentage ? <>
//         <div className="lds-ring-kw">
//             <div></div><div></div><div></div><div></div>
//             <span className='percentage-loaded'>{props.percentage+"%"}</span>
//         </div>

//     </> : <div className="lds-ring-kw"><div></div><div></div><div></div><div></div></div>

//     return content

// }

// export default SpinnerKw;